import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  InputNumber,
  useSelect,
  Select,
  Row,
  Col,
  Button,
  Progress,
  Icons,
  Typography,
  Space,
  Divider,
  Spin,
  notification,
  message,
} from '@pankod/refine-antd'
import { useCreateMany, useGetIdentity } from '@pankod/refine-core'
import { getLastEvaluation, getPaperById, getQuestionLookupIdsByUuids } from 'gql/query'
import { IEvaluationMain, IGradeLevel, IMedium, IPaper, IQuestionType } from 'interfaces'
import { useEffect, useState } from 'react'
import type { NotificationPlacement } from 'antd/es/notification'
import { processMcqAnalysis } from 'helpers/question/mcqEvaluation'
import { CSVLink } from 'react-csv'
import { normalizeEvaluationUploadFile } from 'helpers/evaluations/convertResponseReportFormat'
type CreateGradeProps = {
  modalProps: ModalProps
  formProps: FormProps
  close: any
  record: any
  refreshTable: any
}
type QuestionAnswer = {
  id: string
  number: number
  option: string
  mark: number
  questionType: string
}
type EvaluationDetails = {
  candidate_id: string
  candidate_name: string
  application_id: string
  candidate_image: string
  total_score: number
  answers: object[]
  created_by: string
  evaluation_id: string

  attempted: number
  correct: number
}
type FileDetails = {
  lastModified: any
  name: string
}

export const CreateEvaluation: React.FC<CreateGradeProps> = ({ modalProps, formProps, close, record, refreshTable }) => {
  const { data: user } = useGetIdentity()
  const [file, setFile] = useState<FileDetails>()
  const [showFileName, setFileName] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showUpload, setShowUpload] = useState(true)
  const { mutate } = useCreateMany<IEvaluationMain>()
  const [array, setArray] = useState('')
  const [percent, setPercent] = useState(0)
  const [disableSaveBtn, setDisableSaveBtn] = useState(false)
  const [currentPaperDetails, setCurrentPaperDetails] = useState<QuestionAnswer[]>([])
  const [evaluationData, setEvaluationData] = useState<EvaluationDetails[]>([])
  const [mcqAnalysisReportData, setMcqAnalysisReportData] = useState<any>()
  const { selectProps: paperProps, queryResult } = useSelect<IPaper>({
    resource: 'papers',
    fetchSize: 100,
    optionLabel: 'paper_smart_id',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'paper_smart_id', 'paper_id'],
    },
    sort: [{ field: 'paper_id', order: 'desc' }],
  })

  let paperOptions = []

  if (queryResult?.data?.data !== undefined) {
    const newOptions = queryResult?.data?.data?.map(paper => {
      const label = `${paper?.paper_id}-${paper?.paper_smart_id}`
      const value = paper?.id
      return { label, value }
    })
    paperOptions.push(...newOptions)
  }

  const { selectProps: questionTypeSelectProps } = useSelect<IQuestionType>({
    resource: 'question_types',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
  })
  const openNotification = (placement: NotificationPlacement, message: string, type: 'success' | 'error' | 'info' | 'warning' = 'success') => {
    notification[type]({
      message: type.toUpperCase(),
      description: message,
      placement,
    })
    refreshTable()
  }
  const onFinish = async (values: any) => {
    setDisableSaveBtn(true)
    values['created_by'] = user?.id
    values['paper_id'] = record?.paper_id
    values['evaluation_request_id'] = record?.id
    //  setUploading(true)
    let details: object[] = []
    if (array.length > 0) {
      details.push({ csv: array, formValues: values, paper: record?.paper?.questionAnswerKeys, tq: record?.paper?.product?.tq })
      fetch(`${process.env.REACT_APP_BACKEND_URL}/evaluation-upload`, {
        //  fetch(`http://localhost:3001/evaluation-upload`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        body: JSON.stringify(details),
        headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
      })
        .then(response => response.json())
        .then(async data => {
          setDisableSaveBtn(false)
          setShowUpload(false)
          setLoading(false)
          setFileName(false)
          setEvaluationData([])
          if (data?.statusMessage === 'Success') {
            openNotification('bottomRight', 'Upload Successful! Analysis of the questions is now in progress.')
            const mcqDetails: any = await processMcqAnalysis(record?.paper_id, 30, 'paper')
            if (mcqDetails?.status && mcqDetails?.details?.length > 0) {
              setMcqAnalysisReportData(mcqDetails?.details)
              openNotification('bottomRight', 'Analysis is complete! You can now download the data.')
            }else{
              openNotification('bottomRight', "Analysis could not be completed. Please try again later.", 'error')
              close()
            }
            formProps?.form?.resetFields()
            setShowUpload(true)
          
          } else {
            openNotification('bottomRight', data?.statusMessage, 'error')
            formProps?.form?.resetFields()
            setShowUpload(true)
            close()
          }
        })
    } else {
      message.warning('Please uplaod the file to continue evaluation')
      setLoading(false)
      setDisableSaveBtn(false)
    }
  }
  // const uploadEvaluationDetails = async (data: any) => {
  //   // alert(2)
  //   let details: object[] = []
  //   details.push({ csv: data, paper: currentPaperDetails })
  //   fetch('http://localhost:3001/evaluation-upload', {
  //     method: 'POST', // *GET, POST, PUT, DELETE, etc.
  //     body: JSON.stringify(details),
  //     headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
  //   })
  //     .then(response => response.json())
  //     .then(data => {
  //       setEvaluationData(data)
  //       increase(100)
  //       setFileName(true)
  //       setLoading(true)
  //     })
  // }
  const loadQuestionLookups = async (paperQuestionKeys?: QuestionAnswer[]) => {
    if (!paperQuestionKeys?.length) return []
    const ids = Array.from(new Set(paperQuestionKeys.map(key => key.id).filter(Boolean))) as string[]
    return getQuestionLookupIdsByUuids(ids)
  }

  const handleOnChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const uploadedFile = e.target.files?.[0]
    if (!uploadedFile) return

    setLoading(true)
    setShowUpload(false)
    setFile(uploadedFile)

    try {
      const questionLookups = await loadQuestionLookups(record?.paper?.questionAnswerKeys)
      const { csv, converted, rowCount, questionCount } = await normalizeEvaluationUploadFile(
        uploadedFile,
        record?.paper?.questionAnswerKeys,
        questionLookups
      )
      setArray(csv)
      setFileName(true)
      if (converted) {
        message.success(`Converted ${rowCount} candidate(s) with ${questionCount} question column(s).`)
      }
    } catch (error) {
      message.error(error instanceof Error ? error.message : 'Failed to process the uploaded file.')
      setShowUpload(true)
      setFileName(false)
      setArray('')
      e.target.value = ''
    } finally {
      setLoading(false)
    }
  }

  // const handlePaperChange = (value: { value: any }) => {
  //   getPaperById(value).then((resp: any) => {
  //     setCurrentPaperDetails(resp.papers[0]?.questionAnswerKeys)
  //   })
  //   setShowUpload(true)
  // }
  const removeUploadedFile = () => {
    setShowUpload(true)
    setLoading(false)
    setFileName(false)
    setEvaluationData([])
    setArray('')
  }

  return (
    <Modal
      {...modalProps}
      title="Create Evaluation"
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      afterClose={() => {
        setDisableSaveBtn(false)
        // setShowUpload(false)
        setLoading(false)
        setFileName(false)
        setEvaluationData([])
        setArray('')
      }}
    >
      <Form {...formProps} size="large" layout="vertical" onFinish={onFinish}>
        <Row gutter={[16, 0]}>
          <Col lg={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="Name" />
            </Form.Item>
          </Col>
          {/* <Col lg={12}>
            <Form.Item
              label="Paper"
              name="paper_id"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select {...paperProps} onChange={handlePaperChange} placeholder="Paper" options={paperOptions} />
            </Form.Item>
            {/* <Form.Item name="created_by" initialValue={user?.id}>
              <Input type="hidden" />
            </Form.Item> */}
          {/* </Col> */}
          {/* <Col xs={24} lg={12}>
            <Form.Item name={'question_type_id'} rules={[{ required: true }]}>
              <Select {...questionTypeSelectProps} placeholder="Question Type" />
            </Form.Item>
          </Col> */}
          {showUpload ? (
            <Col lg={24}>
              <div className="upload-btn-wrapper" style={{ marginTop: 10 }}>
                <button className="btn">Upload a file</button>
                <input type="file" name="myfile" id={'csvFileInput'} accept=".csv,.xlsx,.xls" onChange={handleOnChange} />
              </div>
            </Col>
          ) : null}
        </Row>
        {/* {loading ? <Progress percent={percent} /> : null} */}
        <>
          {showFileName ? (
            <Space>
              <Icons.FileDoneOutlined style={{ fontSize: 25, color: 'green' }} />
              <Typography.Link>{file?.name}</Typography.Link>
              <Typography.Link onClick={() => removeUploadedFile()}>Remove</Typography.Link>
            </Space>
          ) : null}
        </>

        <Divider />
        <Spin spinning={disableSaveBtn} />
        <Row gutter={[16, 0]} justify="end" align="top">
          <Col xs={24} lg={8} style={{ display: 'flex', justifyContent: 'end' }}>
            <Space>
              <Button onClick={() => close()}>Cancel</Button>
              <Button type="primary" htmlType="submit" disabled={disableSaveBtn}>
                Save
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
      {mcqAnalysisReportData && mcqAnalysisReportData?.length > 0 && (
        <>
          <CSVLink
            key="export"
            data={mcqAnalysisReportData}
            filename={`${record?.paper?.paper_id}_paper_mcq_analysis${Math.round(new Date().getTime() / 1000)}`}
          >
            <Icons.ExportOutlined /> Download MCQ Analysis Sheet
          </CSVLink>
        </>
      )}
    </Modal>
  )
}
